import script from "./LoteUbicacion.vue?vue&type=script&setup=true&lang=js"
export * from "./LoteUbicacion.vue?vue&type=script&setup=true&lang=js"

import "./LoteUbicacion.vue?vue&type=style&index=0&id=4fa521ff&lang=css"

const __exports__ = script;

export default __exports__